import {ApiClient} from '@hconnect/apiclient'
import {useMutation, useQueryClient, UseMutationOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {QueryKey} from '../../events/hooks'
import {CreateMaintenanceNotification} from '../types'

type UseMaintenanceNotificationParams = {
  plantId: string
  options?: UseMutationOptions<string, AxiosError, CreateMaintenanceNotification>
}

export const useMaintenanceNotification = ({
  plantId,
  options
}: UseMaintenanceNotificationParams) => {
  const queryClient = useQueryClient()

  return useMutation<string, AxiosError, CreateMaintenanceNotification>({
    mutationFn: async ({sourceEventId, workCenterId, plannerGroupId, attachmentIds}) => {
      const path = `/shifthandover/${plantId}/maintenance-notification`

      const mutation = await ApiClient.axiosInstance.post<string>(path, {
        sourceEventId,
        workCenterId,
        plannerGroupId,
        ...(attachmentIds && attachmentIds.length > 0 ? {attachmentIds} : {})
      })

      return mutation.data
    },
    ...options,
    onSuccess: async (data, variables, context, mutation) => {
      await queryClient.invalidateQueries({queryKey: [QueryKey, variables.sourceEventId]})
      await options?.onSuccess?.(data, variables, context, mutation)
    }
  })
}
